import { createContext } from "react";
import { noop } from "lodash";

import { TransactionRuleGroup } from "../../../common/types/transactionRule";

interface Context {
    updateRuleGroup(ruleGroup: TransactionRuleGroup | null): void;
    deleteRuleGroup(ruleGroup: TransactionRuleGroup | null): void;
    createRuleGroup(type: "transaction" | "accounting"): void;
    ruleGroupToUpdate: TransactionRuleGroup | null;
    ruleGroupToDelete: TransactionRuleGroup | null;
    isCreatingRuleGroup: string | null;
}

export const TransactionRuleManagementContext = createContext<Context>({
    updateRuleGroup: noop,
    deleteRuleGroup: noop,
    createRuleGroup: noop,
    ruleGroupToUpdate: null,
    ruleGroupToDelete: null,
    isCreatingRuleGroup: null,
});
